import React, { useState, useEffect } from "react";
import { useSelector, connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import Login from "./login";
import Signup from "./signup";
import FreeVersionRoutes from "./free";
import StandardVersionRoutes from "./standard";
import PremiumVersionRoutes from "./premium";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import NoInternet from "./noInternet";
import { logout } from "./redux/actions/login";
import { isMobile } from "react-device-detect";
// import PaymentConfirmation from "./paymentConfirmation";
import { toAbsoluteUrl } from "./services";

// get user data from state
const authData = (state) => state.auth;

function App(props) {
  const data = useSelector(authData);
  const [isOnline, setOnline] = useState(true);

  let { loggedIn, userType } = data;

  // On initization set the isOnline state.
  useEffect(() => {
    setOnline(navigator.onLine);
  }, []);

  // event listeners to update the state
  window.addEventListener("online", () => {
    setOnline(true);
  });

  window.addEventListener("offline", () => {
    setOnline(false);
  });

  useEffect(() => {
    window.addEventListener("storage", function (event) {
      // Check if the storage event was triggered for session storage
      if (event.storageArea === sessionStorage) {
        // Clear the session storage
        sessionStorage.clear();
        this.window.location.reload();
      }
    });
  }, []);

  return (
    <div>
      {isOnline ? (
        <>
          {isMobile === true ? (
            <div className="flex flex-col items-center justify-center mt-[30%]">
              <img src={toAbsoluteUrl("/media/login/desktop.png")} />
              <h4 className="text-center">
                This Product is available only on Desktop!
              </h4>
            </div>
          ) : (
            <>
              {loggedIn === true && userType === "free" ? (
                <FreeVersionRoutes />
              ) : loggedIn === true && userType === "standard" ? (
                <StandardVersionRoutes />
              ) : loggedIn === true && userType === "premium" ? (
                <PremiumVersionRoutes />
              ) : (
                <HashRouter hashType="noslash">
                  <Routes history={History}>
                    <Route index path={`/`} element={<Login />} />
                    <Route path={'/signup'} element={ <Signup tier="free"/>} />
                    {/* <Route
                      path={`/confirmation`}
                      element={<PaymentConfirmation />}
                    /> */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </HashRouter>
              )}
            </>
          )}
        </>
      ) : (
        <NoInternet />
      )}
    </div>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { logout })(App);
